import I18n from 'I18n';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Select } from 'foundations-components/components/Select';
import { useCallback, useEffect, useState } from 'react';
import { DEBOUNCE_TIME } from '../../../constants/Http';
import { ASSOCIATION_OBJECT_PROPERTIES } from '../../../constants/associations';
import { searchObject } from '../../../data/api/crmV3Api';
import captureException from '../../../utils/captureException';
import { formatObject } from '../../../utils/objectFormatters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociateExistingCrmObjectTab({
  objectType,
  setAssociationCandidates,
  searchObjectApi = searchObject,
  appName = 'in-meeting-experience-ui-components'
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [searchedObjects, setSearchedObjects] = useState([]);
  const turnOffLoader = () => setIsLoading(false);
  const setCandidates = useCallback(candidates => {
    setAssociationCandidates(candidates);
  }, [setAssociationCandidates]);
  useEffect(() => {
    const data = {
      objectType,
      query: searchTerm,
      after: '0',
      limit: 10,
      properties: ASSOCIATION_OBJECT_PROPERTIES[objectType]
    };
    searchObjectApi(data, DEBOUNCE_TIME).then(response => {
      const options = response.results.map(item => formatObject(item, objectType));
      setSearchedObjects(options);
    }).catch(error => {
      captureException(error);
    }).finally(turnOffLoader);
  }, [objectType, searchTerm, searchObjectApi]);
  useEffect(() => () => {
    setCandidates([]);
  }, [setCandidates]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isLoading ? /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true,
      size: "md"
    }) : null, /*#__PURE__*/_jsx(Select, {
      "data-test-id": `${appName}-association-modal-panel-select-input`,
      multi: true,
      options: searchedObjects,
      selectedItemsPlaceholder: I18n.text('associationModals.search.searchPlaceholder', {
        objectType
      }),
      onInputValueChange: setSearchTerm,
      onSelectedOptionChange: ({
        selectedValues
      }) => setCandidates(selectedValues),
      searchable: true
    })]
  });
}
export default AssociateExistingCrmObjectTab;